<template>
<div class="recommendation">
  <div class="title">{{ $t('poi.dishRecommend') }}</div>
  <cube-scroll ref="scroll"
                :data="list"
                direction="horizontal"
                class="list">
    <div class="dish" v-for="(item, index) in list" :key="index">
      <img v-lazy="item.image_url" />
      <div class="dish-name">{{ item.name }}</div>
    </div>
  </cube-scroll>
</div>
</template>

<script>
export default {
    props: {
        list: {
            type: Array,
            default: () => {
                return []
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.recommendation {
  padding: 20px 0 24px;
  border-top: 8px solid #f0f0f0;
}

.recommendation .title {
  font-size: 16px;
  font-weight: bold;
  font-family: "Montserrat";
  margin-bottom: 10px;
  padding: 0 12px;
}

.list {
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
}

.list .dish {
  display: inline-block;
  margin: 0 4px;
  position: relative;
}

.list .dish:first-child {
  margin-left: 12px;
}

.list .dish:last-child {
  margin-right: 12px;
}

.dish .dish-name {
  position: absolute;
  height: 26px;
  background: rgba(0, 0, 0, 0.45);
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #ffffff;
}

.dish img {
  background-color: #d8d8d8;
  width: 90px;
  height: 90px;
  object-fit: cover;
  display: block;
}
</style>